import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import AdditionalFilter from 'af-components/Table/Filters/AdditionalFilter/Singleselect';

import * as CrewTypeActions from 'af-actions/crewType';

export interface CredentialFilter {
	id: number;
	field: CredentialFilterOption;
}

type CredentialFieldType = 'issuedDate' | 'expirationDate';

type CredentialSortType = 'ASC' | 'DESC';

export interface CredentialFilterOption {
	id: string;
	value: CredentialFieldType;
	label: string;
	sort: CredentialSortType;
}

interface OwnProps {
	onChange: (options: CredentialFilterOption, organizationCredentialId: number) => void;
	selected: Nullable<CredentialFilterOption>;
	organizationCredentialId: number;
	onClear?: (id: number) => void;
	autoOpen?: boolean;
	label: string;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const OPTIONS = [
	{
		id: 'issuedDateASC',
		value: 'issuedDate',
		label: 'Issued Date',
		sort: 'ASC',
	},
	{
		id: 'issuedDateDESC',
		value: 'issuedDate',
		label: 'Issued Date',
		sort: 'DESC',
	},
	{
		id: 'expirationDateASC',
		value: 'expirationDate',
		label: 'Expiration Date',
		sort: 'ASC',
	},
	{
		id: 'expirationDateDESC',
		value: 'expirationDate',
		label: 'Expiration Date',
		sort: 'DESC',
	},
];

const CredentialsFilter: React.FC<Props> = (props) => {
	const {
		onChange,
		selected,
		onClear,
		autoOpen,
		label,
		organizationCredentialId,
	} = props;

	const onValueChange = React.useCallback((_option: CredentialFilterOption) => {
		onChange(_option, organizationCredentialId);
	}, [onChange, organizationCredentialId]);

	const renderOption = React.useCallback((option: CredentialFilterOption) => {
		return (
			<>
				{option.label} ({option.sort})
			</>
		);
	}, []);

	const onRemove = React.useCallback(() => {
		onClear?.(organizationCredentialId);
	}, [onClear, organizationCredentialId]);

	return (
		<AdditionalFilter
			autoOpen={!!autoOpen}
			filterName={label}
			forBulkModal={false}
			onChange={onValueChange}
			onRemoveFilter={onRemove}
			options={OPTIONS}
			renderOptionOverride={renderOption}
			selected={selected}
		/>
	);
};

function mapDispatchToProps() {
	return {
		findAllForFieldReportFilter: CrewTypeActions.findAllForCompanyWithInternal,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(CredentialsFilter);
